'use client';

import { useTranslations } from '@/i18n/useTranslations';
import { Button } from '@/components/ui/button';
import { X, Pin, PinOff, Plus, MessageSquare, ShieldCheck, ShieldOff } from 'lucide-react';
import { useAiChatStore } from '@/stores/ai-chat-store';

interface AiPanelHeaderProps {
  onNewConversation: () => void;
}

export function AiPanelHeader({ onNewConversation }: AiPanelHeaderProps) {
  const t = useTranslations('ai');
  const isFloating = useAiChatStore((s) => s.isFloating);
  const autoApprove = useAiChatStore((s) => s.autoApprove);
  const setOpen = useAiChatStore((s) => s.setOpen);
  const setFloating = useAiChatStore((s) => s.setFloating);
  const setConversationListOpen = useAiChatStore((s) => s.setConversationListOpen);
  const setAutoApprove = useAiChatStore((s) => s.setAutoApprove);

  return (
    <div className="flex items-center justify-between px-3 py-2 border-b border-surface">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => setConversationListOpen(true)}>
          <MessageSquare className="h-4 w-4" />
        </Button>
        <span className="text-sm font-semibold">{t('title')}</span>
      </div>
      <div className="flex items-center gap-1">
        <Button
          variant={autoApprove ? 'default' : 'ghost'}
          size="icon"
          className="h-7 w-7"
          onClick={() => setAutoApprove(!autoApprove)}
          title={autoApprove ? t('autoApproveOn') : t('autoApproveOff')}
        >
          {autoApprove ? <ShieldCheck className="h-4 w-4" /> : <ShieldOff className="h-4 w-4" />}
        </Button>
        <Button variant="ghost" size="icon" className="h-7 w-7" onClick={onNewConversation} title={t('newChat')}>
          <Plus className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7"
          onClick={() => setFloating(!isFloating)}
          title={isFloating ? t('pinToSidebar') : t('floatMode')}
        >
          {isFloating ? <Pin className="h-4 w-4" /> : <PinOff className="h-4 w-4" />}
        </Button>
        <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => setOpen(false)}>
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
